import React from "react";
import { Link } from "react-router-dom";
import { SocialIcon } from "react-social-icons";

const Copyright = () => {
  const quickLinks = [
    {
      path: "/",
      title: "How It Works",
    },
    {
      path: "/faqs",
      title: "FAQs",
    },
    {
      path: "/",
      title: "Glossary",
    },
    {
      path: "/",
      title: "Volunteer Form",
    },
    {
      path: "/",
      title: "Careers",
    },
    {
      path: "/",
      title: "Privacy",
    },
    {
      path: "/",
      title: "Terms of Use",
    },
  ];
  const about = [
    {
      path: "/",
      title: "Who we are",
    },
    {
      path: "/",
      title: "How To Raise Funds",
    },
    {
      path: "/price",
      title: "Pricing & Fees",
    },
    {
      path: "/",
      title: "Advertising",
    },
    {
      path: "/",
      title: "Campaign Advertising",
    },
    {
      path: "/",
      title: "Press Release",
    },
  ];

  return (
    <div className="py-10 bg-primary w-screen ">
      <div className="container mx-auto flex flex-col gap-10">
        <div className="flex gap-10 flex-col lg:flex-row px-4">
          <div className="text-white lg:w-1/3 lg:text-2xl font-bold">
            DonorAssist, Inc. is a Benefit Corporation that NEVER forwards money
            to recipients, ONLY products & services on their Charity Registry
            “Wish-List”.
          </div>
          <div className="flex flex-col text-white lg:w-3/12 lg:text-lg">
            <div className="font-extrabold">QUICK LINKS</div>
            {quickLinks.map((item) => {
              return <Link to={item.path}>{item.title}</Link>;
            })}
          </div>
          <div className="flex flex-col text-white lg:w-3/12 lg:text-lg">
            <div className="font-extrabold">ABOUT</div>
            {about.map((item) => {
              return <Link to={item.path}>{item.title}</Link>;
            })}
          </div>
          <div className="flex flex-col text-white lg:w-3/12 lg:text-lg">
            <div className="font-extrabold">CONTACTS</div>
            <div>833-DONORASSIST(366-6727)</div>
            <div>info@donorassist.com</div>
            <Link to="/">Contact Us</Link>
          </div>
        </div>
        <div className=" h-1 bg-secondary container mx-auto"></div>
        <div className="flex gap-6 justify-around flex-col lg:flex-row lg:items-center w-4/5 mx-auto">
          <img
            src={process.env.PUBLIC_URL + "assets/logo/logo-light.svg"}
            alt="logo"
            width={400}
          />
          <div className="text-light font-bold">
            2022 DONORASSIST, INC. <span className="text-2xl">|</span> ALL
            RIGHTS RESERVED.
          </div>
          <div className="flex gap-2">
            <SocialIcon
              network="facebook"
              bgColor="#fff"
              className="hover: cursor-pointer"
            />
            <SocialIcon
              network="twitter"
              bgColor="#fff"
              className="hover: cursor-pointer"
            />
            <SocialIcon
              network="linkedin"
              bgColor="#fff"
              className="hover: cursor-pointer"
            />
            <SocialIcon
              network="instagram"
              bgColor="#fff"
              className="hover:cursor-pointer"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Copyright;
